import classes from "./CryptosSummary.module.css";

const CryptosSummary = () => {
  return (
    <section className={classes.summary}>
      <h2>Bitcoin, ether, libra, stablecoin: wat zijn crypto’s?</h2>
      <p>
        Crypto’s zijn digitale tegoeden die beheerd worden met cryptografische
        algoritmes. Een crypto heeft dus geen fysieke vorm zoals een euromunt,
        maar is eigenlijk een versleutelde code zoals een wachtwoord. Er zijn
        verschillende soorten crypto’s. Bitcoin is waarschijnlijk de bekendste
        crypto, maar er zijn nog honderden andere ontstaan. Bijvoorbeeld ether,
        litecoin en ripple.
      </p>
      <p>
        Er zijn ook stablecoins. Dat zijn crypto’s waarvan de waarde is
        gekoppeld aan een andere waarde van bijvoorbeeld een normale valuta of
        goud. Tether en de door Facebook gelanceerde crypto libra zijn daar
        voorbeelden van. Het doel van stablecoins is crypto’s geschikt maken als
        alledaags betaalmiddel.
      </p>
    </section>
  );
};

export default CryptosSummary;